import { Option } from 'features/match/matchSliceTypes';
import { Person } from '../../../interfaces/person';

export default function (players: Person[], staff?: Person[]): Option[] {
  const options = players.map((person: Person) => {
    const label = person.shirtNumber ? `${person.shirtNumber} - ${person.name}` : person.name;

    return {
      label,
      value: person.personId,
      staff: false,
    };
  });
  if (staff && staff?.length > 0) {
    const staffOptions = staff.map((person: Person) => {
      const label = person.shirtNumber ? `${person.shirtNumber} - ${person.name}` : person.name;

      return {
        label,
        value: person.personInTeamId && person.id ? person.id : person.personId,
        staff: true,
      };
    });
    const divider = {
      label: '-----------------------',
      value: -1,
      staff: false,
      divider: true,
    };
    staffOptions.unshift(divider);
    return options.concat(staffOptions);
  }
  return options;
}
